import React from 'react'
import './ServicesImg.css'
const ServicesImg = ({img}) => {
  return (
    <div className="services-img">
        <div className="services-img-container">
            <img src={img} alt="group-services-1" />
        </div>
    </div>
  )
}

export default ServicesImg